exports = module.exports = {
    generateClient: require('./payplus/client')
};